<template>
  <div class="filter" :class="actionInputStyles">
    <automation-action-ai-generated-email-input
      v-if="inputType === 'ai_generated_email'"
      v-model="action_params"
      :action-types="actionTypes"
      :action-name="action_name"
      :initial-attachments="initialAttachments"
      @update:action-name="onAiEmailActionChange"
      @remove-action="removeAction"
    />
    <automation-action-whatsapp-template-input
      v-else-if="inputType === 'send_whatsapp_template'"
      v-model="action_params"
      :action-types="actionTypes"
      :action-name="action_name"
      :delay-minutes="delayMinutes"
      @update:action-name="onAiEmailActionChange"
      @update:delay-minutes="delayMinutes = $event"
      @touch-delay-validation="touchDelayValidation"
      @remove-action="removeAction"
    />
    <div v-else class="filter-inputs">
      <select
        v-model="action_name"
        class="action__question"
        :class="{ 'full-width': !showActionInput }"
        @change="resetAction()"
      >
        <option
          v-for="attribute in actionTypes"
          :key="attribute.key"
          :value="attribute.key"
        >
          {{ attribute.label }}
        </option>
      </select>
      <div v-if="showActionInput" class="filter__answer--wrap">
        <div v-if="inputType" class="w-full">
          <div
            v-if="inputType === 'search_select'"
            :class="value.action_name === 'add_board' ? 'board_pipeline_select_wrap multiselect-wrap--small items-center' : 'multiselect-wrap--small'"
          >
            <multiselect
              v-model="action_params"
              track-by="id"
              label="name"
              :placeholder="$t('FORMS.MULTISELECT.SELECT')"
              selected-label
              :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
              deselect-label=""
              :max-height="160"
              :options="dropdownValues"
              :allow-empty="false"
              :option-height="104"
              :width="180"
            />

            <div
              v-if="this.value.action_name === 'add_board'"
              class="multiselect-wrap--small"
            >
              <multiselect
                v-model="statusValues"
                track-by="id"
                label="name"
                placeholder="Select pipeline"
                selected-label
                deselect-label=""
                select-label=""
                :max-height="160"
                :options="dropdownStatusValues"
                :allow-empty="false"
                :option-height="104"
                :width="180"
                class=""
              />
            </div>
          </div>
          <div
            v-else-if="inputType === 'multi_select'"
            class="multiselect-wrap--small multi-select-scope condition-multiselect"
            :class="{ 'macro-action-input': action_name === 'add_macro' }"
          >
            <multiselect
              v-model="action_params"
              track-by="id"
              label="name"
              :placeholder="$t('FORMS.MULTISELECT.SELECT')"
              :multiple="true"
              selected-label
              :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
              deselect-label=""
              :max-height="160"
              :options="dropdownValues"
              :allow-empty="false"
              :option-height="104"
              :limit="2"
              :limit-text="limitText"
            />
            <input
              v-if="action_name === 'add_macro'"
              v-model.number="delayMinutes"
              type="number"
              min="0"
              :max="macroDelayBounds.MAX"
              class="answer--text-input macro-delay-input"
              placeholder="Delay (min)"
              title="Optional delay in minutes before executing macro"
              @blur="touchDelayValidation"
            />
          </div>
          <input
            v-else-if="inputType === 'email'"
            v-model="action_params"
            type="email"
            class="answer--text-input"
            placeholder="Enter email"
          />
          <input
            v-else-if="inputType === 'url'"
            v-model="action_params"
            type="url"
            class="answer--text-input"
            placeholder="Enter url"
          />
          <automation-action-file-input
            v-if="inputType === 'attachment'"
            v-model="action_params"
            :initial-file-name="initialFileName"
          />
        </div>
      </div>
      <woot-button
        v-if="!isMacro"
        icon="dismiss"
        variant="clear"
        color-scheme="secondary"
        @click="removeAction"
      />
    </div>
    <automation-action-team-message-input
      v-if="inputType === 'team_message'"
      v-model="action_params"
      :teams="dropdownValues"
    />
    <automation-action-api-webhook-input
      v-if="inputType === 'api_webhook'"
      v-model="action_params"
    />
    <automation-action-kivo-webhook-input
      v-if="
        inputType === 'kivo_webhook' ||
          inputType === 'kivo_no_engagement_webhook'
      "
      v-model="action_params"
      :validation="v"
      :show-wait-time="inputType === 'kivo_no_engagement_webhook'"
    />
    <automation-action-reminder-input
      v-if="inputType === 'reminder'"
      v-model="action_params"
    />

    <div v-if="isWhatsappAction">
      <div v-if="isWhatsappAction && getWhatsappTemplateHeader">
        <p class="font-bold mt-4">HEADER</p>
        <img
          v-if="mediaType === 'IMAGE'"
          :src="mediaUrl"
          alt="Header Image"
          class="header-media"
          width="500"
        />

        <!-- Render video for video format -->
        <video
          v-if="mediaType === 'VIDEO'"
          ref="videoPlayer"
          :src="mediaUrl"
          controls
          width="500"
        ></video>

        <iframe
          v-if="mediaType === 'DOCUMENT'"
          :src="mediaUrl"
          class="header-media"
          width="500"
          height="700"
          frameborder="0"
        ></iframe>
            <!-- <input
              type="file"
              class="variable-input"
              :styles="{ marginBottom: 0 }"
              @change="handleFileChange"
            /> -->
      </div>

      <div v-if="isWhatsappAction && getWhatsappTemplateData">
        <p class="font-bold mt-4">BODY</p>
        <woot-message-editor
          v-model="getWhatsappTemplateData"
          rows="5"
          :enable-variables="true"
          :placeholder="$t('AUTOMATION.ACTION.TEAM_MESSAGE_INPUT_PLACEHOLDER')"
          class="action-message"
        />
      </div>
    </div>
    <div v-if="emailTemplateEditorVisible" class="email-template-macro-editors">
      <p class="font-bold mt-4 text-xs text-slate-500 uppercase">
        {{ $t('AUTOMATION.ACTION.EMAIL_TEMPLATE_SUBJECT_LABEL') }}
      </p>
      <woot-message-editor
        v-model="getEmailTemplateSubject"
        rows="2"
        :enable-variables="true"
        :placeholder="$t('AUTOMATION.ACTION.TEAM_MESSAGE_INPUT_PLACEHOLDER')"
        class="action-message"
      />
      <p class="font-bold mt-2 text-xs text-slate-500 uppercase">
        {{ $t('AUTOMATION.ACTION.EMAIL_TEMPLATE_BODY_LABEL') }}
      </p>
      <woot-message-editor
        v-model="getEmailTemplateBody"
        rows="5"
        :enable-variables="true"
        :placeholder="$t('AUTOMATION.ACTION.TEAM_MESSAGE_INPUT_PLACEHOLDER')"
        class="action-message"
      />
      <div
        v-if="emailTemplateAttachmentList.length"
        class="email-template-macro-attachments"
      >
        <p class="font-bold mt-3 text-xs text-slate-500 uppercase">
          {{ $t('AUTOMATION.ACTION.EMAIL_TEMPLATE_ATTACHMENTS_LABEL') }}
        </p>
        <ul class="email-template-macro-attachments__list">
          <li
            v-for="att in emailTemplateAttachmentList"
            :key="att.id || att.filename"
            class="email-template-macro-attachments__item"
          >
            <fluent-icon icon="document" size="14" class="mr-1 text-slate-500" />
            <span>{{ att.filename }}</span>
          </li>
        </ul>
      </div>
    </div>
    <woot-message-editor
      v-if="inputType === 'textarea'"
      v-model="castMessageVmodel"
      rows="4"
      :enable-variables="true"
      :placeholder="$t('AUTOMATION.ACTION.TEAM_MESSAGE_INPUT_PLACEHOLDER')"
      class="action-message"
    />
    <p
      v-if="
        v.action_params.$dirty &&
          v.action_params.$error &&
          !showAiEmailError
      "
      class="filter-error"
    >
      {{ $t('FILTER.EMPTY_VALUE_ERROR') }}
    </p>
    <p v-if="showAiEmailError" class="filter-error">
      {{ aiEmailErrorMessage }}
    </p>
    <p
      v-if="showMacroDelayError"
      class="filter-error"
    >
      Delay must be between {{ macroDelayBounds.MIN }} and
      {{ macroDelayBounds.MAX }} minutes
    </p>
  </div>
</template>

<script>
import AutomationActionTeamMessageInput from './AutomationActionTeamMessageInput.vue';
import AutomationActionFileInput from './AutomationFileInput.vue';
import AutomationActionApiWebhookInput from './AutomationActionApiWebhookInput.vue';
import AutomationActionKivoWebhookInput from './AutomationActionKivoWebhookInput.vue';
import AutomationActionReminderInput from './AutomationActionReminderInput.vue';
import AutomationActionAiGeneratedEmailInput from './AutomationActionAiGeneratedEmailInput.vue';
import AutomationActionWhatsappTemplateInput from './AutomationActionWhatsappTemplateInput.vue';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor';
import VariableList from './conversation/VariableList.vue';
import {
  suggestionsPlugin,
  triggerCharacters,
} from '@chatwoot/prosemirror-schema/src/mentions/plugin';
import { MACRO_DELAY_MINUTES } from 'dashboard/routes/dashboard/settings/automation/constants';
import {
  aiEmailConfigErrorCode,
  aiEmailErrorBounds,
  aiEmailErrorI18nKey,
} from 'dashboard/helper/aiEmailSchedule';

export default {
  components: {
    AutomationActionTeamMessageInput,
    AutomationActionFileInput,
    AutomationActionApiWebhookInput,
    AutomationActionKivoWebhookInput,
    AutomationActionReminderInput,
    AutomationActionAiGeneratedEmailInput,
    AutomationActionWhatsappTemplateInput,
    WootMessageEditor,
    VariableList
  },
  data(){
    return{
    mediaUrl: '',
    shouldShowVariables: false,
    variableSearchTerm: '',
    enableSuggestions: '',
    dropdownStatusValues: [],
    macroDelayBounds: MACRO_DELAY_MINUTES,
    };
  },
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    actionTypes: {
      type: Array,
      default: () => [],
    },
    dropdownValues: {
      type: Array,
      default: () => [],
    },
    v: {
      type: Object,
      default: () => null,
    },
    showActionInput: {
      type: Boolean,
      default: true,
    },
    initialFileName: {
      type: String,
      default: '',
    },
    initialAttachments: {
      type: Array,
      default: () => [],
    },
    isMacro: {
      type: Boolean,
      default: false,
    },
    statusValue: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    action_name: {
      get() {
        if (!this.value) return null;
        return this.value.action_name;
      },
      set(value) {
        const payload = this.value || {};
        this.$emit('input', { ...payload, action_name: value });
      },
    },
    action_params: {
      get() {
        if (!this.value) return null;
        return this.value.action_params;
      },
      set(value) {
        const payload = this.value || {};
        if(this.value?.action_name == "add_board" ){
          this.dropdownStatusValues = value?.statuses_attributes;
        }
        this.$emit('input', { ...payload, action_params: value, status: {} });
      },
    },
    statusValues: {
      get() {
        if (!this.value) return null;
        return this.value.status;
      },
      set(value) {
        const payload = this.value || {};
        console.log("vaueeee", payload);
        this.$emit('input', { ...payload, status: value });
      },
    },
    inputType() {
      return this.actionTypes.find(action => action.key === this.action_name)
        .inputType;
    }, 
    isWhatsappAction() {
      return this.action_name === 'whatsapp_template';
    },
    isEmailTemplateAction() {
      return this.action_name === 'email_template';
    },
    emailTemplateEditorVisible() {
      const p = this.action_params;
      return (
        this.isEmailTemplateAction &&
        p &&
        typeof p === 'object' &&
        !Array.isArray(p) &&
        p.id
      );
    },
    emailTemplateAttachmentList() {
      if (!this.emailTemplateEditorVisible) return [];
      const raw = this.action_params?.attachments;
      return Array.isArray(raw) && raw.length ? raw : [];
    },
    getEmailTemplateSubject: {
      get() {
        if (!this.emailTemplateEditorVisible) return '';
        return this.action_params.subject ?? '';
      },
      set(newValue) {
        const payload = this.value || {};
        const base =
          this.action_params &&
          typeof this.action_params === 'object' &&
          !Array.isArray(this.action_params)
            ? { ...this.action_params }
            : {};
        this.$emit('input', {
          ...payload,
          action_params: { ...base, subject: newValue },
          status: {},
        });
      },
    },
    getEmailTemplateBody: {
      get() {
        if (!this.emailTemplateEditorVisible) return '';
        return this.action_params.body ?? '';
      },
      set(newValue) {
        const payload = this.value || {};
        const base =
          this.action_params &&
          typeof this.action_params === 'object' &&
          !Array.isArray(this.action_params)
            ? { ...this.action_params }
            : {};
        this.$emit('input', {
          ...payload,
          action_params: { ...base, body: newValue },
          status: {},
        });
      },
    },

    getWhatsappTemplateHeader: {
      get() {
        if (this.isWhatsappAction && this.action_params?.components) {
          const headerComponent = this.action_params?.components
            .map(c =>
              c.type === 'HEADER' &&
              (c.format === 'IMAGE' || c.format === 'VIDEO' || c.format === 'DOCUMENT')
                ? c
                : null
            )
            .find(component => component !== null);

          if (headerComponent) {
            this.mediaUrl = headerComponent.example?.header_handle || null;
            this.mediaType = headerComponent.format; // Track media type
            return this.mediaUrl;
          }
        } else if (
          this.isWhatsappAction &&
          this.action_params[0] &&
          this.action_params[0]?.components
        ) {
          const component = this.action_params[0].components[0];
          this.mediaUrl = component?.header_handle || null;
          this.mediaType = component?.format; // Track media type
          return this.mediaUrl;
        } else {
          this.mediaUrl = null;
          this.mediaType = null; // Reset media type
          return null;
        }
      },
    },
    getWhatsappTemplateData: {
      get(){
         if (this.isWhatsappAction && this.action_params.components) {
          return this.action_params?.components?.map((c) => c.text).join("\n")
          }else if(this.isWhatsappAction && this.action_params[0] && this.action_params[0]?.components) {
            return this.action_params[0]?.components[0]?.text
          }else{
            return null
          }
        },

      set(newValue){
        console.log(this.mediaUrl)
        const payload = this.action_name || "whatsapp_template"
        this.$emit('input', { payload, action_params: [this.action_params.id || this.action_params[0].id, newValue, this.mediaUrl, this.mediaType] });
        
      }
    },
    totalInputFields() {
      if (this.isWhatsappAction && this.action_params.components && this.action_params.components[0].example.body_text) {
        return this.action_params.components[0].example.body_text[0];
      }
      return [];
    },
    actionInputStyles() {
      return {
        'has-error': this.v.action_params.$dirty && this.v.action_params.$error,
        'is-a-macro': this.isMacro,
      };
    },
    castMessageVmodel: {
      get() {
        if (Array.isArray(this.action_params)) {
          return this.action_params[0];
        }
        return this.action_params;
      },
      set(value) {
        this.action_params = value;
      },
    },
    delayMinutes: {
      get() {
        if (!this.value) return '';
        return this.value.delay_minutes ?? '';
      },
      set(value) {
        const payload = this.value || {};
        this.$emit('input', { ...payload, delay_minutes: value });
      },
    },
    showMacroDelayError() {
      if (
        this.action_name !== 'add_macro' &&
        this.action_name !== 'send_whatsapp_template'
      ) {
        return false;
      }
      return (
        this.v?.delay_minutes?.$dirty &&
        this.v?.delay_minutes?.$error
      );
    },
    showAiEmailError() {
      return (
        this.action_name === 'send_ai_generated_email' &&
        this.v?.action_params?.$dirty &&
        this.v?.action_params?.$error
      );
    },
    aiEmailErrorMessage() {
      const code = aiEmailConfigErrorCode(this.action_params);
      const key = aiEmailErrorI18nKey(code);
      if (!key) return this.$t('FILTER.EMPTY_VALUE_ERROR');
      const bounds = aiEmailErrorBounds(code);
      return this.$t(key, {
        min: bounds.MIN,
        max: bounds.MAX,
      });
    },
  },
  methods: {
    touchDelayValidation() {
      this.v?.delay_minutes?.$touch();
    },
    async handleFileChange(event) {
      this.file = event.target.files[0];
      if (file) {
        const url = URL.createObjectURL(file);
        this.mediaUrl = encodeURIComponent(url);
        console.log(this.mediaUrl)
        this.$nextTick(() => {
        if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer.load();
          }
        }); 
      }
    },
    removeAction() {
      this.$emit('removeAction');
    },
    resetAction() {
      this.$emit('resetAction');
    },
    limitText(count) {
      return `+${count}`;
    },
    onAiEmailActionChange(newAction) {
      if (newAction === this.action_name) return;
      this.action_name = newAction;
      this.resetAction();
    },
  },
};
</script>

<style lang="scss" scoped>
.filter {
  @apply bg-slate-50 dark:bg-slate-800 p-2 border border-solid border-slate-75 dark:border-slate-600 rounded-md mb-2;

  &.is-a-macro {
    @apply mb-0 bg-white dark:bg-slate-700 p-0 border-0 rounded-none;
  }
}

.no-margin-bottom {
  @apply mb-0;
}

.filter.has-error {
  @apply bg-red-50 dark:bg-red-800/50 border-red-100 dark:border-red-700/50;
}

.filter-inputs {
  @apply flex items-center;
}

.filter-error {
  @apply text-red-500 dark:text-red-200 block my-1 mx-0;
}

.action__question,
.filter__operator {
  @apply mb-0 mr-1;
}

.action__question {
  @apply max-w-[50%];
}

.action__question.full-width {
  @apply max-w-full;
}

.filter__answer--wrap {
  @apply max-w-[50%] flex-grow mr-1 flex w-full items-center justify-start;

  input {
    @apply mb-0;
  }
}
.filter__answer {
  &.answer--text-input {
    @apply mb-0;
  }
}

.filter__join-operator-wrap {
  @apply relative z-20 m-0;
}

.filter__join-operator {
  @apply flex items-center justify-center relative my-2.5 mx-0;

  .operator__line {
    @apply absolute w-full border-b border-solid border-slate-75 dark:border-slate-600;
  }

  .operator__select {
    margin-bottom: var(--space-zero) !important;
    @apply relative w-auto;
  }
}

.multiselect {
  @apply mb-0;
}
.action-message {
  @apply mt-2 mx-0 mb-0;
}
// Prosemirror does not have a native way of hiding the menu bar, hence
:deep(.ProseMirror-menubar) {

  @apply hidden;
}
.automated-mention-box{
  display: flex;
  justify-content: center;
  align-items: baseline;
}
.automated-mention-box label {
  margin: 0px 20px 0px 0px;
}
.whatsapp_action_input_box{
  width: 100% !important;
  height: 100%!important;
}
/* Scoped styles */
::v-deep(.multi-select-scope .multiselect),
::v-deep(.multi-select-scope .multiselect__tags) {
  //height: fit-content;
}

::v-deep(.multi-select-scope .multiselect__tags-wrap) {
  width: 100%;
  overflow-x: hidden;
}

::v-deep(.multi-select-scope .multiselect__tags input) {
  height: 100%;
}

.macro-action-input {
  @apply flex items-center gap-2 w-full;
}

.macro-delay-input {
  @apply w-24 flex-shrink-0 mb-0;
}


::v-deep(.multiselect__content-wrapper) {
  position: static !important;
}
::v-deep .multiselect__input {
  background-color: transparent !important;
}
::v-deep .multiselect__placeholder {
  margin-left: -3px;
}
::v-deep .multiselect__option:not(.multiselect__option--selected)::after {
  content: none !important;
}

// ::v-deep .multiselect {
//   height: fit-content;
// }
::v-deep .multiselect .multiselect__content {
  max-width: none;
}
::v-deep .multiselect, .multiselect__tags{
 //height: fit-content;
}
::v-deep .multiselect__tags{
 // height: fit-content;
}
::v-deep .multiselect__tags-wrap{
  width: 100%;
  overflow-x: hidden;  
}
::v-deep .multiselect__tags input{
  height: 100%;
}
::v-deep .mx-input{
   margin: 0;
}
::v-deep .multiselect__tag-icon {
  background: transparent !important;
}
::v-deep .multiselect__tag-icon::after {
  content: '\00d7' !important; /* × */
  //color: #266d4d !important;
  font-size: 14px !important;
  //line-height: 1 !important;
}
</style>

<style lang="scss">
/* Condition multiselect styles - fix overflow for status conditions */
/* Unscoped to penetrate multiselect component internals */
.multi-select-scope.condition-multiselect {
  .multiselect {
    min-height: 40px;
  }

  .multiselect__tags {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    overflow: hidden;
    padding: 6px 40px 6px 8px;
  }

  .multiselect__tags-wrap {
    display: flex;
    align-items: center;
    gap: 4px;
    max-width: 100%;
    overflow: hidden;
    flex: 1;
  }

  .multiselect__tag {
    flex-shrink: 0;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0 !important;
    padding: 4px 26px 4px 10px;
    font-size: 13px;
    line-height: 1.2;
  }

  .multiselect__tag-icon {
    line-height: 1.4;
    width: 20px;
    text-align: center;
  }

  /* Badge styling for +N count */
  .multiselect__strong {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin: 0 4px;
    padding: 4px 10px;
    font-size: 13px;
    font-weight: 600;
    color: white;
    background-color: #1f93ff;
    border-radius: 12px;
    min-width: 32px;
    height: 26px;
    line-height: 1;
  }
}

.email-template-macro-editors {
  @apply mt-2 px-0;
}

.email-template-macro-attachments {
  @apply mt-2 text-sm text-slate-600 dark:text-slate-300;

  &__list {
    @apply mt-1 space-y-1 pl-0 list-none;
  }

  &__item {
    @apply flex items-center;
  }
}
</style>
